import humanparser from 'humanparser';
import api from '../callApi';
import { requestBraintreePayment } from './braintree';
import { PaymentMethod } from '../enums';

const createPaymentErrorMessage = "Couldn't create payment, try again later";

const getErrorMessage = errorList =>
    errorList && errorList.length ? errorList[0] : createPaymentErrorMessage;

export const initiateDonation = (apiRequestData, data) => {
    const payment = {
        paymentMethod: data.paymentMethod,
        amount: data.amount
    };

    return api
        .post('Widget/InitiateDonationAsync', {
            ...apiRequestData,
            ...payment
        })
        .then(response => {
            if (
                (response.clientToken == null &&
                    data.paymentMethod === PaymentMethod.Braintree) ||
                response.trackingId == null ||
                (response.errorList != null && response.errorList.length)
            ) {
                return Promise.reject(getErrorMessage(response.errorList));
            }
            return { ...data, ...response };
        });
};

export const getPaymentNonceFromCreditCard = (paymentMethod, data) => {
    if (paymentMethod === PaymentMethod.Braintree) {
        return requestBraintreePayment(data);
    }
    if (paymentMethod === PaymentMethod.OrgHunter) {
        return Promise.resolve(data);
    }

    Promise.reject(
        'There was an error with the payment gateway while initiating your donation! Please try again!'
    );
};

const createCompleteDonationRequest = data => {
    const name = humanparser.parseName(data.fullName);
    return {
        user: {
            firstName: name.middleName
                ? name.firstName + ' ' + name.middleName
                : name.firstName,
            lastName: name.lastName,
            email: data.email,
            address: {
                zipCode: data.postalCode
            }
        },
        notifyResult: data.getUpdates,
        trackingId: data.trackingId,
        paymentNonce: data.nonce,
        amount: data.amount,
        actionCompletedTime: data.actionCompleteTime
    };
};

export const completeDonation = (
    apiRequestData,
    data,
    paymentProvider = null,
    deviceData = null
) => {
    const request = {
        ...createCompleteDonationRequest(data),
        ...apiRequestData,
        paymentProvider,
        deviceData
    };

    return api
        .post('Widget/CompleteDonationAsync', request, { useFingerprint: true })
        .then(response => {
            if (
                response.status === 'Rejected' ||
                response.status === 'Error' ||
                response.status === 'ValidationFailed'
            ) {
                return Promise.reject(getErrorMessage(response.errorList));
            }

            return response;
        });
};
